import React, { useState } from "react";

import useLocalStorage from "../../lib/useLocalStorage";
import SweepstakesHeadTags from "../SweepstakesHeadTags";
import useSweepstakesQuery from "../../lib/useSweepstakesQuery";
import { sweepstakesQuery } from "./queries";
import EmailForm from "./EmailForm";
import OtpForm from "./OtpForm";
import ModeSwitch from "../../lib/ModeSwitch";
import EntryList from "./EntryList";
import Page from "./Page";
import Layout from "../Layout";

const EMAIL_STEP = "email";
const OTP_STEP = "otp";
const ENTRY_PAGE_STEP = "entry";

const DonorEntryPage = () => {
  const [authToken, setAuthToken] = useLocalStorage(null, "guest_session_token");
  const { data, loading, error } = useSweepstakesQuery(sweepstakesQuery);
  const step = authToken ? ENTRY_PAGE_STEP : EMAIL_STEP;
  const [greeting, setGreeting] = useState("");

  if (loading || error) {
    return null;
  }

  const { sweepstakes } = data;

  return (
    <React.Fragment>
      <SweepstakesHeadTags sweepstakes={sweepstakes} title={`View Your Entries | ${sweepstakes.headline}`} />
      <Page authToken={authToken} setAuthToken={setAuthToken} greeting={greeting} sweepstakes={sweepstakes}>
        <Layout.FullWidth fold>
          <Layout.FlexibleColumn span={[7, 15]} breakpoint="belowTablet" spaced>
            <ModeSwitch initialMode={step}>
              <EmailForm mode={EMAIL_STEP} sweepstakesId={sweepstakes.id} />
              <OtpForm mode={OTP_STEP} setAuthToken={setAuthToken}/>
              <EntryList mode={ENTRY_PAGE_STEP} authToken={authToken} setAuthToken={setAuthToken} setGreeting={setGreeting} />
            </ModeSwitch>
          </Layout.FlexibleColumn>
        </Layout.FullWidth>
      </Page>
    </React.Fragment>
  );
}

export default DonorEntryPage;
